module.exports = __webpack_public_path__ + "img/herta-kuru_box.0fb274e3.png";